import { MenuItem, Typography } from "@mui/material";
import _ from "lodash";
import { ReactElement, ReactNode } from "react";

import Select from "~frontend/components/forms/FormSelect";
import theme from "~frontend/theme";

export type ContactSource =
  | "CSV"
  | "ActionKitImport"
  | "GCSImport"
  | "ActBlueImport"
  | "FollowUpImport"
  | "NgpVanImport"
  | "SubscriberImport"
  | "AudienceImport";

export type ContactSourceWithDisplayInfo = {
  contactSource: ContactSource;
  label: ReactNode;
  disabled?: boolean;
  disabledReason?: string;
};

export default function ContactSources({
  selectedSource,
  availableSources,
  onSelectSource,
  disabled,
}: {
  selectedSource: ContactSource;
  availableSources: ContactSourceWithDisplayInfo[];
  onSelectSource: (newSource: ContactSource) => void;
  disabled?: boolean;
}): ReactElement {
  if (availableSources.length === 1) {
    return <></>;
  }

  const [disabledSources, enabledSources] = _.partition(
    availableSources,
    source => source.disabled
  );

  return (
    <>
      <Typography variant="h2" sx={{ marginBottom: theme.spacing(3) }}>
        Choose your contact load method below and complete the following steps
        to build your contact list.
      </Typography>
      <Select
        label="Contact Load Method"
        value={selectedSource}
        onChange={ev => {
          const newSource = ev.target.value as ContactSource;
          if (newSource !== selectedSource && onSelectSource) {
            onSelectSource(newSource);
          }
        }}
        disabled={disabled}
        fullWidth
        sx={{ marginBottom: "40px" }}
      >
        {[...enabledSources, ...disabledSources].map(
          ({ contactSource, label, disabled, disabledReason }) => (
            <MenuItem
              key={contactSource}
              value={contactSource}
              disabled={disabled}
            >
              {label}
              {disabled && disabledReason ? ` (${disabledReason})` : null}
            </MenuItem>
          )
        )}
      </Select>
    </>
  );
}
